// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.canvas-login-page {
  position: relative;
  display: grid;
  min-height: 100vh;
  grid-template-columns: minmax(0, 1.2fr) minmax(380px, 0.8fr);
  overflow: hidden;
  color: #f4f0e6;
  background: #11120f;
}

.canvas-login-grid {
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0.17;
  background-image:
    linear-gradient(rgba(216, 255, 69, 0.23) 1px, transparent 1px),
    linear-gradient(90deg, rgba(216, 255, 69, 0.23) 1px, transparent 1px);
  background-size: 52px 52px;
  mask-image: linear-gradient(90deg, #000, transparent 72%);
}

.canvas-login-intro {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: clamp(48px, 8vw, 120px);
}

.canvas-login-intro::after {
  position: absolute;
  right: 6%;
  bottom: -14%;
  width: 360px;
  height: 360px;
  content: '';
  border: 1px solid rgba(216, 255, 69, 0.4);
  border-radius: 48% 52% 62% 38%;
  transform: rotate(26deg);
  box-shadow: inset 0 0 100px rgba(216, 255, 69, 0.06);
}

.canvas-login-kicker {
  margin-bottom: 28px;
  color: #8f9586;
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: 11px;
  letter-spacing: 0.14em;
}

.canvas-login-kicker span { color: #d8ff45; }

.canvas-login-intro h1 {
  margin: 0;
  font-family: 'Avenir Next Condensed', 'Arial Narrow', sans-serif;
  font-size: clamp(56px, 7vw, 108px);
  font-weight: 800;
  letter-spacing: -0.055em;
  line-height: 0.92;
}

.canvas-login-intro h1 em {
  color: #d8ff45;
  font-family: Georgia, 'Songti SC', serif;
  font-weight: 400;
}

.canvas-login-intro > p {
  max-width: 570px;
  margin: 34px 0 42px;
  color: #aeb3a5;
  font-family: Georgia, 'Songti SC', serif;
  font-size: clamp(16px, 1.4vw, 21px);
  line-height: 1.75;
}

.canvas-login-proof { display: flex; gap: 34px; color: #747a6d; font-size: 12px; }
.canvas-login-proof span { display: flex; align-items: baseline; gap: 7px; }
.canvas-login-proof b { color: #f4f0e6; font-family: Georgia, serif; font-size: 25px; }

.canvas-login-panel {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: clamp(44px, 7vw, 100px);
  color: #11120f;
  background: #eeebe2;
  box-shadow: -28px 0 80px rgba(0, 0, 0, 0.28);
}

.canvas-login-panel header { display: flex; align-items: center; gap: 14px; margin-bottom: 38px; }
.canvas-login-panel header > div { display: flex; flex-direction: column; }
.canvas-login-panel header strong { font-size: 17px; letter-spacing: 0.12em; }
.canvas-login-panel header small { margin-top: 3px; color: #73786d; font-family: Georgia, serif; font-style: italic; }

.canvas-login-logo, .canvas-auth-callback-mark {
  display: grid;
  width: 44px;
  height: 44px;
  place-items: center;
  color: #11120f;
  background: #d8ff45;
  border-radius: 4px 16px 4px 4px;
  font-family: Georgia, serif;
  font-size: 26px;
  font-weight: 800;
}

.canvas-login-google {
  display: flex;
  width: 100%;
  min-height: 48px;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #11120f;
  background: transparent;
  border: 1px solid #b6bab1;
  border-radius: 4px;
  font-weight: 600;
  transition: transform 160ms ease, background 160ms ease;
}

.canvas-login-google:hover:not(:disabled) { background: #f8f5ec; border-color: #777d70; transform: translateY(-1px); }
.canvas-login-google:disabled { cursor: wait; opacity: 0.68; }
.canvas-login-google svg { width: 21px; height: 21px; }

.canvas-login-wechat-heading { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.canvas-login-wechat-heading h2 { margin: 0; font-size: 16px; font-weight: 700; }
.canvas-login-wechat-heading span { padding: 4px 9px; color: #496600; background: #eaff9d; border-radius: 999px; font-size: 10px; font-weight: 700; }
.canvas-login-wechat-primary { padding: 10px; background: rgba(216, 255, 69, 0.12); border: 1px solid rgba(157, 190, 38, 0.52); border-radius: 6px 26px 6px 6px; }

.canvas-login-divider { display: flex; align-items: center; gap: 12px; margin: 22px 0 16px; color: #757a6f; font-size: 12px; }
.canvas-login-divider span { height: 1px; flex: 1; background: #cfccc3; }

.canvas-login-qr {
  display: grid;
  min-height: 252px;
  place-items: center;
  background: #f8f5ec;
  border: 1px solid #cbc8be;
  border-radius: 4px 24px 4px 4px;
}

.canvas-login-qr img { width: 224px; height: 224px; image-rendering: crisp-edges; }
.canvas-login-qr button { padding: 12px 18px; color: #11120f; background: #d8ff45; border: 0; border-radius: 999px; }
.canvas-login-loader { color: #6f7569; font-family: 'SFMono-Regular', Consolas, monospace; font-size: 12px; }
.canvas-login-qr-caption { margin: 12px 0 2px; color: #6b7066; text-align: center; font-size: 12px; }
.canvas-login-panel footer { margin-top: 22px; color: #90948b; text-align: center; font-size: 10px; }
.canvas-login-methods { width: 100%; }

.canvas-login-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 5000;
  display: grid;
  overflow-y: auto;
  place-items: center;
  padding: 24px;
  background: rgba(17, 18, 15, 0.58);
  animation: canvas-login-modal-fade-in 160ms ease-out;
  backdrop-filter: blur(8px);
}

.canvas-login-modal {
  width: min(420px, 100%);
  max-height: calc(100vh - 48px);
  overflow-y: auto;
  padding: 28px;
  background: #fff;
  border: 1px solid #d8dcd7;
  border-radius: 16px;
  box-shadow: 0 28px 90px rgba(17, 18, 15, 0.28);
  animation: canvas-login-modal-enter 180ms ease-out;
}

.canvas-login-modal-close {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 1;
  display: grid;
  width: 32px;
  height: 32px;
  padding: 0;
  place-items: center;
  color: #73786d;
  background: #f4f5f3;
  border: 1px solid #e0e3df;
  border-radius: 50%;
  font-size: 21px;
  line-height: 1;
}

.canvas-login-modal-close:hover { color: #11120f; background: #e9ebe8; }

@keyframes canvas-login-modal-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes canvas-login-modal-enter {
  from { opacity: 0; transform: translateY(10px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.canvas-auth-callback {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 22px;
  color: #f4f0e6;
  background: #11120f;
}

.canvas-auth-callback h1 { margin: 0; font-family: Georgia, 'Songti SC', serif; font-size: 22px; font-weight: 400; }
.canvas-auth-callback-error .canvas-auth-callback-mark { color: #fff; background: #ff6b35; }

@media (max-width: 900px) {
  .canvas-login-page { display: block; background: #eeebe2; }
  .canvas-login-intro { min-height: 42vh; padding: 48px 28px; }
  .canvas-login-intro h1 { font-size: clamp(46px, 13vw, 72px); }
  .canvas-login-intro > p, .canvas-login-proof { display: none; }
  .canvas-login-panel { min-height: 58vh; padding: 42px 28px 54px; box-shadow: 0 -28px 60px rgba(0,0,0,.28); }
  .canvas-login-modal { min-height: auto; padding: 24px; box-shadow: 0 28px 90px rgba(17, 18, 15, 0.28); }
  .canvas-login-modal-backdrop { padding: 14px; }
}

@media (prefers-reduced-motion: reduce) {
  .canvas-login-modal,
  .canvas-login-modal-backdrop { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/login/login.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,4DAA4D;EAC5D,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,aAAa;EACb;;yEAEuE;EACvE,0BAA0B;EAC1B,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,WAAW;EACX,yCAAyC;EACzC,8BAA8B;EAC9B,wBAAwB;EACxB,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kDAAkD;EAClD,eAAe;EACf,sBAAsB;AACxB;;AAEA,4BAA4B,cAAc,EAAE;;AAE5C;EACE,SAAS;EACT,gEAAgE;EAChE,kCAAkC;EAClC,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,wCAAwC;EACxC,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA,sBAAsB,aAAa,EAAE,SAAS,EAAE,cAAc,EAAE,eAAe,EAAE;AACjF,2BAA2B,aAAa,EAAE,qBAAqB,EAAE,QAAQ,EAAE;AAC3E,wBAAwB,cAAc,EAAE,2BAA2B,EAAE,eAAe,EAAE;;AAEtF;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;EACd,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA,6BAA6B,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACjG,mCAAmC,aAAa,EAAE,sBAAsB,EAAE;AAC1E,oCAAoC,eAAe,EAAE,sBAAsB,EAAE;AAC7E,mCAAmC,eAAe,EAAE,cAAc,EAAE,2BAA2B,EAAE,kBAAkB,EAAE;;AAErH;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,uDAAuD;AACzD;;AAEA,4CAA4C,mBAAmB,EAAE,qBAAqB,EAAE,2BAA2B,EAAE;AACrH,gCAAgC,YAAY,EAAE,aAAa,EAAE;AAC7D,2BAA2B,WAAW,EAAE,YAAY,EAAE;;AAEtD,+BAA+B,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,mBAAmB,EAAE;AACxH,kCAAkC,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAChF,oCAAoC,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE,oBAAoB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACpJ,+BAA+B,aAAa,EAAE,oCAAoC,EAAE,0CAA0C,EAAE,+BAA+B,EAAE;;AAEjK,wBAAwB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE;AAC7H,6BAA6B,WAAW,EAAE,OAAO,EAAE,mBAAmB,EAAE;;AAExE;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA,uBAAuB,YAAY,EAAE,aAAa,EAAE,4BAA4B,EAAE;AAClF,0BAA0B,kBAAkB,EAAE,cAAc,EAAE,mBAAmB,EAAE,SAAS,EAAE,oBAAoB,EAAE;AACpH,uBAAuB,cAAc,EAAE,kDAAkD,EAAE,eAAe,EAAE;AAC5G,2BAA2B,kBAAkB,EAAE,cAAc,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACpG,6BAA6B,gBAAgB,EAAE,cAAc,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACpG,wBAAwB,WAAW,EAAE;;AAErC;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,oDAAoD;EACpD,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,aAAa;EACb,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,kCAAkC,cAAc,EAAE,mBAAmB,EAAE;;AAEvE;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,mBAAmB;AACrB;;AAEA,2BAA2B,SAAS,EAAE,wCAAwC,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACnH,yDAAyD,WAAW,EAAE,mBAAmB,EAAE;;AAE3F;EACE,qBAAqB,cAAc,EAAE,mBAAmB,EAAE;EAC1D,sBAAsB,gBAAgB,EAAE,kBAAkB,EAAE;EAC5D,yBAAyB,kCAAkC,EAAE;EAC7D,+CAA+C,aAAa,EAAE;EAC9D,sBAAsB,gBAAgB,EAAE,uBAAuB,EAAE,wCAAwC,EAAE;EAC3G,sBAAsB,gBAAgB,EAAE,aAAa,EAAE,8CAA8C,EAAE;EACvG,+BAA+B,aAAa,EAAE;AAChD;;AAEA;EACE;iCAC+B,eAAe,EAAE;AAClD","sourcesContent":[".canvas-login-page {\n  position: relative;\n  display: grid;\n  min-height: 100vh;\n  grid-template-columns: minmax(0, 1.2fr) minmax(380px, 0.8fr);\n  overflow: hidden;\n  color: #f4f0e6;\n  background: #11120f;\n}\n\n.canvas-login-grid {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  opacity: 0.17;\n  background-image:\n    linear-gradient(rgba(216, 255, 69, 0.23) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(216, 255, 69, 0.23) 1px, transparent 1px);\n  background-size: 52px 52px;\n  mask-image: linear-gradient(90deg, #000, transparent 72%);\n}\n\n.canvas-login-intro {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: clamp(48px, 8vw, 120px);\n}\n\n.canvas-login-intro::after {\n  position: absolute;\n  right: 6%;\n  bottom: -14%;\n  width: 360px;\n  height: 360px;\n  content: '';\n  border: 1px solid rgba(216, 255, 69, 0.4);\n  border-radius: 48% 52% 62% 38%;\n  transform: rotate(26deg);\n  box-shadow: inset 0 0 100px rgba(216, 255, 69, 0.06);\n}\n\n.canvas-login-kicker {\n  margin-bottom: 28px;\n  color: #8f9586;\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  font-size: 11px;\n  letter-spacing: 0.14em;\n}\n\n.canvas-login-kicker span { color: #d8ff45; }\n\n.canvas-login-intro h1 {\n  margin: 0;\n  font-family: 'Avenir Next Condensed', 'Arial Narrow', sans-serif;\n  font-size: clamp(56px, 7vw, 108px);\n  font-weight: 800;\n  letter-spacing: -0.055em;\n  line-height: 0.92;\n}\n\n.canvas-login-intro h1 em {\n  color: #d8ff45;\n  font-family: Georgia, 'Songti SC', serif;\n  font-weight: 400;\n}\n\n.canvas-login-intro > p {\n  max-width: 570px;\n  margin: 34px 0 42px;\n  color: #aeb3a5;\n  font-family: Georgia, 'Songti SC', serif;\n  font-size: clamp(16px, 1.4vw, 21px);\n  line-height: 1.75;\n}\n\n.canvas-login-proof { display: flex; gap: 34px; color: #747a6d; font-size: 12px; }\n.canvas-login-proof span { display: flex; align-items: baseline; gap: 7px; }\n.canvas-login-proof b { color: #f4f0e6; font-family: Georgia, serif; font-size: 25px; }\n\n.canvas-login-panel {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: clamp(44px, 7vw, 100px);\n  color: #11120f;\n  background: #eeebe2;\n  box-shadow: -28px 0 80px rgba(0, 0, 0, 0.28);\n}\n\n.canvas-login-panel header { display: flex; align-items: center; gap: 14px; margin-bottom: 38px; }\n.canvas-login-panel header > div { display: flex; flex-direction: column; }\n.canvas-login-panel header strong { font-size: 17px; letter-spacing: 0.12em; }\n.canvas-login-panel header small { margin-top: 3px; color: #73786d; font-family: Georgia, serif; font-style: italic; }\n\n.canvas-login-logo, .canvas-auth-callback-mark {\n  display: grid;\n  width: 44px;\n  height: 44px;\n  place-items: center;\n  color: #11120f;\n  background: #d8ff45;\n  border-radius: 4px 16px 4px 4px;\n  font-family: Georgia, serif;\n  font-size: 26px;\n  font-weight: 800;\n}\n\n.canvas-login-google {\n  display: flex;\n  width: 100%;\n  min-height: 48px;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  color: #11120f;\n  background: transparent;\n  border: 1px solid #b6bab1;\n  border-radius: 4px;\n  font-weight: 600;\n  transition: transform 160ms ease, background 160ms ease;\n}\n\n.canvas-login-google:hover:not(:disabled) { background: #f8f5ec; border-color: #777d70; transform: translateY(-1px); }\n.canvas-login-google:disabled { cursor: wait; opacity: 0.68; }\n.canvas-login-google svg { width: 21px; height: 21px; }\n\n.canvas-login-wechat-heading { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }\n.canvas-login-wechat-heading h2 { margin: 0; font-size: 16px; font-weight: 700; }\n.canvas-login-wechat-heading span { padding: 4px 9px; color: #496600; background: #eaff9d; border-radius: 999px; font-size: 10px; font-weight: 700; }\n.canvas-login-wechat-primary { padding: 10px; background: rgba(216, 255, 69, 0.12); border: 1px solid rgba(157, 190, 38, 0.52); border-radius: 6px 26px 6px 6px; }\n\n.canvas-login-divider { display: flex; align-items: center; gap: 12px; margin: 22px 0 16px; color: #757a6f; font-size: 12px; }\n.canvas-login-divider span { height: 1px; flex: 1; background: #cfccc3; }\n\n.canvas-login-qr {\n  display: grid;\n  min-height: 252px;\n  place-items: center;\n  background: #f8f5ec;\n  border: 1px solid #cbc8be;\n  border-radius: 4px 24px 4px 4px;\n}\n\n.canvas-login-qr img { width: 224px; height: 224px; image-rendering: crisp-edges; }\n.canvas-login-qr button { padding: 12px 18px; color: #11120f; background: #d8ff45; border: 0; border-radius: 999px; }\n.canvas-login-loader { color: #6f7569; font-family: 'SFMono-Regular', Consolas, monospace; font-size: 12px; }\n.canvas-login-qr-caption { margin: 12px 0 2px; color: #6b7066; text-align: center; font-size: 12px; }\n.canvas-login-panel footer { margin-top: 22px; color: #90948b; text-align: center; font-size: 10px; }\n.canvas-login-methods { width: 100%; }\n\n.canvas-login-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 5000;\n  display: grid;\n  overflow-y: auto;\n  place-items: center;\n  padding: 24px;\n  background: rgba(17, 18, 15, 0.58);\n  animation: canvas-login-modal-fade-in 160ms ease-out;\n  backdrop-filter: blur(8px);\n}\n\n.canvas-login-modal {\n  width: min(420px, 100%);\n  max-height: calc(100vh - 48px);\n  overflow-y: auto;\n  padding: 28px;\n  background: #fff;\n  border: 1px solid #d8dcd7;\n  border-radius: 16px;\n  box-shadow: 0 28px 90px rgba(17, 18, 15, 0.28);\n  animation: canvas-login-modal-enter 180ms ease-out;\n}\n\n.canvas-login-modal-close {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  z-index: 1;\n  display: grid;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  place-items: center;\n  color: #73786d;\n  background: #f4f5f3;\n  border: 1px solid #e0e3df;\n  border-radius: 50%;\n  font-size: 21px;\n  line-height: 1;\n}\n\n.canvas-login-modal-close:hover { color: #11120f; background: #e9ebe8; }\n\n@keyframes canvas-login-modal-fade-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes canvas-login-modal-enter {\n  from { opacity: 0; transform: translateY(10px) scale(0.98); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n.canvas-auth-callback {\n  display: flex;\n  min-height: 100vh;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 22px;\n  color: #f4f0e6;\n  background: #11120f;\n}\n\n.canvas-auth-callback h1 { margin: 0; font-family: Georgia, 'Songti SC', serif; font-size: 22px; font-weight: 400; }\n.canvas-auth-callback-error .canvas-auth-callback-mark { color: #fff; background: #ff6b35; }\n\n@media (max-width: 900px) {\n  .canvas-login-page { display: block; background: #eeebe2; }\n  .canvas-login-intro { min-height: 42vh; padding: 48px 28px; }\n  .canvas-login-intro h1 { font-size: clamp(46px, 13vw, 72px); }\n  .canvas-login-intro > p, .canvas-login-proof { display: none; }\n  .canvas-login-panel { min-height: 58vh; padding: 42px 28px 54px; box-shadow: 0 -28px 60px rgba(0,0,0,.28); }\n  .canvas-login-modal { min-height: auto; padding: 24px; box-shadow: 0 28px 90px rgba(17, 18, 15, 0.28); }\n  .canvas-login-modal-backdrop { padding: 14px; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .canvas-login-modal,\n  .canvas-login-modal-backdrop { animation: none; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
